import React from 'react';
import {ICollapsibleArrowProps} from "../collapsible.types";
import Icon from "../../icons/icon/icon";
import IconNext from "../../icons/icon-next/icon-next";
import './trigger-arrow2.scss';
import {ICON_SIZE} from "../../icons/icon-props-interface";

const TriggerArrow2: React.FC<ICollapsibleArrowProps> = ({ isExpanded }) => {
    return (
        <div className={`collapsible-trigger-arrow2 ${isExpanded ? 'is-expanded' : ''}`}>
            <Icon color={'var(--color-primary-2)'} size={ICON_SIZE.MEDIUM} Component={IconNext} />
        </div>
    )
}

export default TriggerArrow2;